import { render, staticRenderFns } from "./ChatterIcon.vue?vue&type=template&id=d2f394e2"
import script from "./ChatterIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatterIcon.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChatterIcon.vue?vue&type=style&index=0&id=d2f394e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports